/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import * as global from "../../js/global";
	import * as helper from "../../js/helper";
	import full_loading from "../components/full-loading.vue";
	import property_component from "../components/property-component.vue";
	const __vue_script__ ={
        components: {
            full_loading:full_loading,
            property_component:property_component,
        },
		name:'my_properties_widget',
        props: { 
        },
		data() {
			return {
                global,
                helper,
                frappe,
                is_loading:false,
				connections: [],
                messages:[],
                selected_ref:null,
                selected_message:null,
                maintenance_expense:0,
                maintenance_expense_description:null
			}
		},
        mounted(){
            this.get_connections();
        },
		methods: {
            get_connections: async function(){
                if(this.is_loading)
                    return;
                this.is_loading = true;
                let params = {};
                let res = await $.ajax({
                    url: "/api/method/maalek.api.get_connections",
                    type: "GET",
                    data: params
                });
                this.connections = res.message;
                console.log(this.connections);
                this.is_loading = false;
            },
            get_messages: async function(){
                if(this.is_loading)
                    return;
                global.emitter.emit("show-full-loading");
                this.is_loading = true;
                this.messages = [];
                let params = {
                    "ref_name":this.selected_ref
                };
                let res = await $.ajax({
                    url: "/api/method/maalek.api.get_messages",
                    type: "GET",
                    data: params
                });
                this.messages = res.message;
                this.is_loading = false;
                this.get_connections();
                global.emitter.emit("refresh-message-count");
                global.emitter.emit("hide-full-loading");
            },
            set_visit_request: async function(message_name,status){
                if (!["Accept","Reject"].includes(status))
                    return;
                if(this.is_loading)
                    return;
                this.is_loading = true;
                global.emitter.emit("show-full-loading");
                let params = {
                    "message_name": message_name
                };
                if (status == "Accept"){
                    try {
                        let res = await $.ajax({
                            url: "/api/method/maalek.api.accept_visit_request",
                            type: "GET",
                            data: params
                        });
                        helper.showSuccess("Contact request accepted",()=>{
                            // location.reload();
                        });
                    } catch (e) {
                        console.log(e);
                        var exceptions = helper.showException(e);
                    }
                }else{
                    try {
                        let res = await $.ajax({
                            url: "/api/method/maalek.api.reject_visit_request",
                            type: "GET",
                            data: params
                        });
                        helper.showSuccess("Contact request rejected",()=>{
                            // location.reload();
                        });
                    } catch (e) {
                        console.log(e);
                        var exceptions = helper.showException(e);
                    }
                }
                this.is_loading = false;
                global.emitter.emit("hide-full-loading");
                this.get_messages();
            },
            confirm_set_maintenance_request: async function(message_name,status){
                if(status == "Completed"){
                    this.set_maintenance_request(message_name,status);
                }else{
                    bootbox.confirm({
                        message: `<div class="alert alert-danger" role="alert">
                                <b>`+helper.t("Warning: you cannot undo this action.")+`</b><br>
                                `+helper.t("Do you want to cancel the maintenance request?")+`
                        </div>`,
                        buttons: {
                            confirm: {
                                label: helper.t("Yes"),
                                className: 'btn-success'
                            },
                            cancel: {
                                label: helper.t("No"),
                                className: 'btn-danger'
                            }
                        },
                        backdrop: true,
                        callback: (results) => results?this.set_maintenance_request(message_name,status):console.log("cancel"),
                    });
                }
            },
            set_maintenance_request: async function(message_name,status){
                if (!["Completed","Canceled"].includes(status))
                    return;
                if(this.is_loading)
                    return;
                this.is_loading = true;
                global.emitter.emit("show-full-loading");
                let params = {
                    "message_name": message_name
                };
                if (status == "Completed"){
                    params["expense"] =  this.maintenance_expense;
                    params["expense_description"] =  this.maintenance_expense_description;
                    try {
                        let res = await $.ajax({
                            url: "/api/method/maalek.api.complete_maintenance_request",
                            type: "GET",
                            data: params
                        });
                        helper.showSuccess("Maintenance request completed",()=>{
                            // location.reload();
                        });
                    } catch (e) {
                        console.log(e);
                        var exceptions = helper.showException(e);
                    }
                }else{
                    try {
                        let res = await $.ajax({
                            url: "/api/method/maalek.api.cancel_maintenance_request",
                            type: "GET",
                            data: params
                        });
                        helper.showSuccess("Maintenance request canceled",()=>{
                            // location.reload();
                        });
                    } catch (e) {
                        console.log(e);
                        var exceptions = helper.showException(e);
                    }
                }
                global.emitter.emit("hide-full-loading");
                this.is_loading = false;
                this.hide_complete_maintenance_modal();
                this.get_messages();
            },
            show_complete_maintenance_modal: function(){
                this.maintenance_expense = 0;
                this.maintenance_expense_description = null;
                $('#complete_maintenance_modal').modal('show');
            },
            hide_complete_maintenance_modal: function(){
                $('#complete_maintenance_modal').modal('hide');
            }
		},
		computed:{
		}
	}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "message" }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c("full_loading"),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-9" }, [
          _c("div", { staticClass: "message-wrap" }, [
            _c(
              "div",
              {
                staticClass:
                  "review-date d-flex justify-content-between align-items-center"
              },
              [
                _c("div", { staticClass: "date" }, [
                  _c("h3", [_vm._v(_vm._s(_vm.helper.t("Messages")))])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "massage-list" },
              _vm._l(_vm.messages, function(message) {
                return message.data
                  ? _c(
                      "li",
                      {
                        class:
                          message.direction == "Out"
                            ? "left-chat d-flex justify-content-end"
                            : "right-chat d-flex justify-content-start"
                      },
                      [
                        message.type == "Visit"
                          ? _c("div", { staticStyle: { "min-width": "80%" } }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "message-header d-flex justify-content-between px-2"
                                },
                                [
                                  _c("span", [
                                    _c("b", [
                                      _vm._v(_vm._s(message.full_name) + " ◀")
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  message.status == "Accepted"
                                    ? _c("span", [
                                        _c("i", {
                                          staticClass: "fa-solid fa-phone fa-xs"
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              "0" +
                                                message.connection_user.substr(
                                                  4
                                                )
                                            )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              false
                                ? _c("img", {
                                    attrs: {
                                      src:
                                        "/assets/maalek/images/messages/messages-2.jpg",
                                      alt: "Image"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              message.direction == "In"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "message-body",
                                      class: message.unread ? "unread" : ""
                                    },
                                    [
                                      message.status == "Pending"
                                        ? _c("p", [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.helper.t(
                                                    "Wants to contact"
                                                  )
                                                ) +
                                                "\n                                    "
                                            )
                                          ])
                                        : message.status == "Accepted"
                                        ? _c("p", [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.helper.t(
                                                    "You accepted contact request"
                                                  )
                                                ) +
                                                "\n                                    "
                                            )
                                          ])
                                        : message.status == "Rejected"
                                        ? _c("p", [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.helper.t(
                                                    "You rejected contact request"
                                                  )
                                                ) +
                                                "\n                                    "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("p", [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "text-success text-decoration-underline fw-bold",
                                            attrs: {
                                              href: "/property/" + message.doc,
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            message.data["parent_property"]
                                              ? [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        _vm.helper.t(
                                                          "Floor#{0}, {1}: {2}",
                                                          [
                                                            message.data[
                                                              "floor_num"
                                                            ],
                                                            message.data[
                                                              "property_type"
                                                            ],
                                                            message.data[
                                                              "title"
                                                            ]
                                                          ]
                                                        )
                                                      ) +
                                                      "\n                                            "
                                                  )
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      ]),
                                      _vm._v(" "),
                                      message.status == "Pending"
                                        ? _c("p", [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn default-btn mt-2",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.set_visit_request(
                                                      message.name,
                                                      "Accept"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.helper.t("Accept"))
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn submit-btn mt-2",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.set_visit_request(
                                                      message.name,
                                                      "Reject"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.helper.t("Reject"))
                                                )
                                              ]
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass: "message-body",
                                      class: message.unread ? "unread" : ""
                                    },
                                    [
                                      message.status == "Pending"
                                        ? _c("p", [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.helper.t(
                                                    "Contact request sent"
                                                  )
                                                ) +
                                                "\n                                    "
                                            )
                                          ])
                                        : message.status == "Accepted"
                                        ? _c("p", [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.helper.t(
                                                    "Contact request accepted"
                                                  )
                                                ) +
                                                "\n                                    "
                                            )
                                          ])
                                        : _c("p", [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.helper.t(
                                                    "Contact request rejected"
                                                  )
                                                ) +
                                                "\n                                    "
                                            )
                                          ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "text-success text-decoration-underline fw-bold",
                                            attrs: {
                                              href: "/property/" + message.doc,
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            message.data["parent_property"]
                                              ? [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        _vm.helper.t(
                                                          "Floor#{0}, {1}: {2}",
                                                          [
                                                            message.data[
                                                              "floor_num"
                                                            ],
                                                            message.data[
                                                              "property_type"
                                                            ],
                                                            message.data[
                                                              "title"
                                                            ]
                                                          ]
                                                        )
                                                      ) +
                                                      "\n                                            "
                                                  )
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      ])
                                    ]
                                  ),
                              _vm._v(" "),
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "message-footer d-flex justify-content-end"
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.helper.toMomentStringTranslation(
                                          message.creation
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            ])
                          : message.type == "Maintenance"
                          ? _c("div", { staticStyle: { "min-width": "80%" } }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "message-header d-flex justify-content-between px-2"
                                },
                                [
                                  _c("span", [
                                    _c("b", [
                                      _vm._v(_vm._s(message.full_name) + " ◀")
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _c("i", {
                                      staticClass: "fa-solid fa-phone fa-xs"
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          "0" +
                                            message.connection_user.substr(4)
                                        )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              message.direction == "In"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "message-body",
                                      class: message.unread ? "unread" : ""
                                    },
                                    [
                                      message.status == "Pending"
                                        ? _c("p", [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.helper.t(
                                                    "maintenance request ({0})",
                                                    [message.data["reason"]]
                                                  )
                                                ) +
                                                "\n                                    "
                                            )
                                          ])
                                        : message.status == "Completed"
                                        ? _c("p", [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.helper.t(
                                                    "You completed ({0}) maintenance request",
                                                    [message.data["reason"]]
                                                  )
                                                ) +
                                                "\n                                    "
                                            )
                                          ])
                                        : message.status == "Canceled"
                                        ? _c("p", [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.helper.t(
                                                    "You canceled ({0}) maintenance request",
                                                    [message.data["reason"]]
                                                  )
                                                ) +
                                                "\n                                    "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("p", [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "text-success text-decoration-underline fw-bold",
                                            attrs: {
                                              href:
                                                "/account/my-deals?deal=" +
                                                message.data["deal_name"],
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.helper.t("Deal# {0}", [
                                                    message.data["deal_name"]
                                                  ])
                                                ) +
                                                "\n                                        "
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(_vm.helper.t("Details:")) +
                                            " "
                                        ),
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(message.data["details"])
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      message.status == "Pending"
                                        ? _c("p", [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn default-btn mt-2",
                                                on: {
                                                  click: function($event) {
                                                    _vm.selected_message =
                                                      message.name
                                                    _vm.show_complete_maintenance_modal()
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.helper.t("Complete")
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn submit-btn mt-2",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.confirm_set_maintenance_request(
                                                      message.name,
                                                      "Canceled"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.helper.t("Cancel"))
                                                )
                                              ]
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass: "message-body",
                                      class: message.unread ? "unread" : ""
                                    },
                                    [
                                      message.status == "Pending"
                                        ? _c("p", [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.helper.t(
                                                    "Your maintenance request ({0}) sent",
                                                    [message.data["reason"]]
                                                  )
                                                ) +
                                                "\n                                    "
                                            )
                                          ])
                                        : message.status == "Completed"
                                        ? _c("p", [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.helper.t(
                                                    "Your ({0}) maintenance is resolved",
                                                    [message.data["reason"]]
                                                  )
                                                ) +
                                                "\n                                    "
                                            )
                                          ])
                                        : _c("p", [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.helper.t(
                                                    "({0}) Maintenance is canceled",
                                                    [message.data["reason"]]
                                                  )
                                                ) +
                                                "\n                                    "
                                            )
                                          ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "text-success text-decoration-underline fw-bold",
                                            attrs: {
                                              href:
                                                "/account/occupied-properties?deal=" +
                                                message.data["deal_name"],
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.helper.t("Deal# {0}", [
                                                    message.data["deal_name"]
                                                  ])
                                                ) +
                                                "\n                                        "
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(_vm.helper.t("Details:")) +
                                            " "
                                        ),
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(message.data["details"])
                                          )
                                        ])
                                      ])
                                    ]
                                  ),
                              _vm._v(" "),
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "message-footer d-flex justify-content-end"
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.helper.t(
                                          "Created: {0} - Updated: {1}",
                                          [
                                            _vm.helper.toMomentStringTranslation(
                                              message.creation
                                            ),
                                            _vm.helper.toMomentStringTranslation(
                                              message.modified
                                            )
                                          ]
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            ])
                          : _vm._e()
                      ]
                    )
                  : _vm._e()
              }),
              0
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-3" }, [
          _c("div", { staticClass: "user-list" }, [
            _c(
              "ul",
              _vm._l(_vm.connections, function(connection) {
                return _c(
                  "li",
                  {
                    key: connection.doc,
                    class: _vm.selected_ref == connection.doc ? "selected" : "",
                    on: {
                      click: function($event) {
                        _vm.selected_ref = connection.doc
                        _vm.get_messages()
                      }
                    }
                  },
                  [
                    connection.doc_type == "Property"
                      ? _c("h4", { staticClass: "pt-2" }, [
                          _c(
                            "div",
                            { staticClass: "d-flex justify-content-between" },
                            [
                              _c("p", { staticClass: "p-0 m-0" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.helper.t("{0} for {1}", [
                                      connection.data["property_type"],
                                      connection.data["ad_type"]
                                    ])
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", [_vm._v(_vm._s(connection.doc))])
                            ]
                          ),
                          _vm._v(" "),
                          connection.member_full_name
                            ? _c("small", [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm.helper.t("Managed By: {0}", [
                                        connection.member_full_name
                                      ])
                                    )
                                ),
                                _c("br")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          false && "Dont remove it" == ""
                            ? _c("small", [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm.helper.t("{0}, {1}, {2}", [
                                        connection.data[
                                          "district_name_" + _vm.frappe.lang
                                        ],
                                        connection.data[
                                          "city_name_" + _vm.frappe.lang
                                        ],
                                        connection.data[
                                          "region_name_" + _vm.frappe.lang
                                        ]
                                      ])
                                    ) +
                                    "\n                                "
                                )
                              ])
                            : _vm._e()
                        ])
                      : connection.doc_type == "User Maalek"
                      ? _c("h4", { staticClass: "pt-2" }, [
                          _vm._v(_vm._s("Interests"))
                        ])
                      : _c("h4", { staticClass: "pt-2" }, [
                          _vm._v(_vm._s(connection.doc))
                        ]),
                    _vm._v(" "),
                    connection.unread_count > 0
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "position-absolute top-50 start-100 translate-middle badge rounded-pill bg-danger"
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(connection.unread_count) +
                                "\n                            "
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                )
              }),
              0
            )
          ])
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade filter-popup-area",
        attrs: {
          id: "complete_maintenance_modal",
          "data-bs-backdrop": "static",
          "data-bs-keyboard": "false",
          tabindex: "-1",
          "aria-labelledby": "staticBackdropLabel",
          "aria-hidden": "true"
        }
      },
      [
        _c(
          "div",
          {
            staticClass:
              "modal-dialog modal-dialog-centered modal-dialog-scrollable"
          },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c(
                  "h5",
                  {
                    staticClass: "modal-title",
                    attrs: { id: "staticBackdropLabel" }
                  },
                  [_vm._v(_vm._s(_vm.helper.t("Complete maintenace request")))]
                ),
                _vm._v(" "),
                _c("button", {
                  staticClass: "btn-close",
                  attrs: {
                    type: "button",
                    "data-bs-dismiss": "modal",
                    "aria-label": "Close"
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col" }, [
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.helper.t(
                                "Expense against this maintenance request?"
                              )
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [
                          _vm._v(_vm._s(_vm.helper.t("Expense (optional)")))
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.maintenance_expense,
                              expression: "maintenance_expense"
                            }
                          ],
                          staticClass: "form-control border-radius",
                          attrs: { type: "number" },
                          domProps: { value: _vm.maintenance_expense },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.maintenance_expense = $event.target.value
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.helper.t("Expense Description (optional)")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.maintenance_expense_description,
                              expression: "maintenance_expense_description"
                            }
                          ],
                          staticClass: "form-control border-radius",
                          attrs: { cols: "30", rows: "6", maxlength: "255" },
                          domProps: {
                            value: _vm.maintenance_expense_description
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.maintenance_expense_description =
                                $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("small", [
                          _vm._v(_vm._s(_vm.helper.t("Max. {0}", [255])))
                        ])
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col text-end" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn default-btn mt-2 show-hand",
                        on: {
                          click: function($event) {
                            return _vm.set_maintenance_request(
                              _vm.selected_message,
                              "Completed"
                            )
                          }
                        }
                      },
                      [_c("p", [_vm._v(_vm._s(_vm.helper.t("Complete")))])]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn default-btn mt-2",
                        on: {
                          click: function($event) {
                            return _vm.hide_complete_maintenance_modal()
                          }
                        }
                      },
                      [_c("p", [_vm._v(_vm._s(_vm.helper.t("No wait!")))])]
                    )
                  ])
                ])
              ])
            ])
          ]
        )
      ]
    )
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-52d8d657_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"messages-widget.vue"}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/widgets/messages-widget.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__